import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const TrustBar = () => {
  const stats = [
    { label: "Circulating Supply", val: "708.4M", icon: "Activity" },
    { label: "Sacred Burned", val: "69.3M", icon: "Zap" },
    { label: "Network", val: "XPR", icon: "Globe" },
    { label: "Treasury Lock", val: "Verified", icon: "Shield" }
  ];

  return (
    <section className="relative z-20 py-12 -mt-16">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div 
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="glass-panel rounded-[2.5rem] p-10 grid grid-cols-2 lg:grid-cols-4 gap-8 border-white/5"
        >
          {stats.map((stat, i) => (
            <div key={i} className="text-center lg:text-left flex lg:flex-row flex-col items-center gap-4 group">
              <div className="w-14 h-14 rounded-2xl bg-white/5 flex items-center justify-center group-hover:bg-purple-500/20 transition-all duration-500">
                <SafeIcon name={stat.icon} className="text-purple-400 w-6 h-6" />
              </div>
              <div>
                <p className="text-slate-500 text-xs uppercase font-bold tracking-widest mb-1">{stat.label}</p>
                <p className="text-2xl font-bold text-white tracking-tight">{stat.val}</p>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TrustBar;